import { Navigate } from 'react-router-dom'

// Redirect is removed from v5, v6 that's why we use this trick
function Home () {
  return <Navigate to='/portfolio' replace />
}

export default Home
